import React, { useEffect, useState } from 'react';
import { ShieldCheck, AlertTriangle, ChevronDown, Star } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 59,
    s: 47
  });
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [selectedPlan, setSelectedPlan] = useState<'pro' | 'basic'>('pro');
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.s > 0) return {
          ...prev,
          s: prev.s - 1
        };
        if (prev.m > 0) return {
          ...prev,
          m: prev.m - 1,
          s: 59
        };
        if (prev.h > 0) return {
          h: prev.h - 1,
          m: 59,
          s: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  return <section id="pricing" className="py-24 bg-surface border-t border-white/5 relative overflow-hidden" data-id="element-191">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[500px] bg-gold/5 rounded-full blur-[150px] pointer-events-none" data-id="element-192"></div>

      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-193">
        {/* Countdown */}
        <FadeIn data-id="element-194">
          <div className="text-center mb-16" data-id="element-195">
            <h2 className="text-3xl md:text-4xl font-bold mb-8 text-white" data-id="element-196">
              ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
            </h2>

            <div className="flex justify-center gap-4 mb-6" data-id="element-197">
              <div className="bg-background border border-gold/30 w-20 h-24 md:w-24 md:h-28 rounded-xl flex flex-col items-center justify-center shadow-[0_0_15px_rgba(212,168,67,0.1)]" data-id="element-198">
                <span className="text-4xl md:text-5xl font-bold text-gold font-heading" data-id="element-199">
                  {formatTime(timeLeft.h)}
                </span>
                <span className="text-xs text-gray-400 uppercase mt-2" data-id="element-200">
                  Horas
                </span>
              </div>
              <div className="text-4xl md:text-5xl font-bold text-gold/50 self-center pb-6" data-id="element-201">
                :
              </div>
              <div className="bg-background border border-gold/30 w-20 h-24 md:w-24 md:h-28 rounded-xl flex flex-col items-center justify-center shadow-[0_0_15px_rgba(212,168,67,0.1)]" data-id="element-202">
                <span className="text-4xl md:text-5xl font-bold text-gold font-heading" data-id="element-203">
                  {formatTime(timeLeft.m)}
                </span>
                <span className="text-xs text-gray-400 uppercase mt-2" data-id="element-204">
                  Min
                </span>
              </div>
              <div className="text-4xl md:text-5xl font-bold text-gold/50 self-center pb-6" data-id="element-205">
                :
              </div>
              <div className="bg-background border border-gold/30 w-20 h-24 md:w-24 md:h-28 rounded-xl flex flex-col items-center justify-center shadow-[0_0_15px_rgba(212,168,67,0.1)]" data-id="element-206">
                <span className="text-4xl md:text-5xl font-bold text-gold font-heading" data-id="element-207">
                  {formatTime(timeLeft.s)}
                </span>
                <span className="text-xs text-gray-400 uppercase mt-2" data-id="element-208">
                  Seg
                </span>
              </div>
            </div>

            <div className="inline-flex items-center gap-2 text-yellow bg-yellow/10 px-4 py-2 rounded-full text-sm font-medium mb-6" data-id="element-209">
              ⚠️ Después sube $12.000 ARS. No vuelve.
            </div>

            {/* Scarcity Bar */}
            <div className="max-w-md mx-auto bg-surfaceLight/50 rounded-xl p-4 border border-red-500/20" data-id="element-210">
              <div className="flex items-center justify-between mb-2" data-id="element-211">
                <span className="text-red-400 font-bold text-sm flex items-center gap-2" data-id="element-212">
                  <span className="relative flex h-2 w-2" data-id="element-213">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-214"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500" data-id="element-215"></span>
                  </span>
                  🔴 Quedan pocos cupos al precio de lanzamiento
                </span>
              </div>
              <div className="w-full bg-background rounded-full h-2.5 mb-2 overflow-hidden border border-white/5" data-id="element-216">
                <div className="bg-gradient-to-r from-red-500 to-red-400 h-2.5 rounded-full" style={{
                width: '72%'
              }} data-id="element-217"></div>
              </div>
              <p className="text-xs text-gray-400 text-right" data-id="element-218">
                72% de los cupos ya tomados
              </p>
            </div>
          </div>
        </FadeIn>

        {/* Pricing Selector */}
        <FadeIn delay={0.1} data-id="element-219">
          <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-10" data-id="element-220">
            ELEGÍ TU <span className="text-gold" data-id="element-221">KIT DE RESCATE</span>
          </h2>
        </FadeIn>

        <div id="elegir-plan" className="max-w-2xl mx-auto mb-24" data-id="element-222">
          {/* Basic Plan Option */}
          <FadeIn delay={0.1} data-id="element-223">
            <button onClick={() => setSelectedPlan('basic')} className={`w-full text-left rounded-2xl p-6 mb-4 transition-all duration-300 border-2 ${selectedPlan === 'basic' ? 'border-gold shadow-[0_0_25px_rgba(212,168,67,0.15)] bg-surfaceLight/60' : 'border-white/10 bg-background hover:border-white/20'}`} data-id="element-224">
              <div className="flex items-start gap-4" data-id="element-225">
                {/* Radio */}
                <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${selectedPlan === 'basic' ? 'border-gold' : 'border-gray-500'}`} data-id="element-226">
                  {selectedPlan === 'basic' && <div className="w-2.5 h-2.5 rounded-full bg-gold" data-id="element-227"></div>}
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0" data-id="element-228">
                  <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4" data-id="element-229">
                    <div data-id="element-230">
                      <h3 className="text-xl font-bold text-white flex items-center gap-2 mb-1" data-id="element-231">
                        <span data-id="element-232">🩹</span> KIT ADULTO DE RESCATE
                      </h3>
                      <p className="text-gray-400 text-sm mb-3" data-id="element-233">
                        6 Módulos + 4 Bonos
                      </p>
                      <div className="bg-surfaceLight/50 px-3 py-2 rounded-lg border border-white/5 text-xs text-gray-300 inline-block" data-id="element-234">
                        <span className="font-semibold text-white" data-id="element-235">
                          Ideal para:
                        </span>{' '}
                        Padres que quieren herramientas tácticas para todas las
                        crisis de la adolescencia
                      </div>
                    </div>
                    <div className="sm:text-right shrink-0" data-id="element-236">
                      <span className="text-gray-500 line-through text-sm block" data-id="element-237">
                        $54.000
                      </span>
                      <span className="text-3xl font-bold text-white font-heading" data-id="element-238">
                        $19.990
                      </span>
                      <span className="text-sm text-gray-400 ml-1" data-id="element-239">ARS</span>
                    </div>
                  </div>
                </div>
              </div>
            </button>
          </FadeIn>

          {/* Pro Plan Option */}
          <FadeIn delay={0.2} data-id="element-240">
            <div className="relative" data-id="element-241">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 z-10" data-id="element-242">
                <span className="bg-gold text-background font-bold px-4 py-1 rounded-full text-xs uppercase tracking-wider" data-id="element-243">
                  Más Elegido ⭐
                </span>
              </div>
              <button onClick={() => setSelectedPlan('pro')} className={`w-full text-left rounded-2xl p-6 transition-all duration-300 border-2 ${selectedPlan === 'pro' ? 'border-gold shadow-[0_0_25px_rgba(212,168,67,0.15)] bg-surfaceLight/60' : 'border-white/10 bg-background hover:border-white/20'}`} data-id="element-244">
                <div className="flex items-start gap-4" data-id="element-245">
                  {/* Radio */}
                  <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${selectedPlan === 'pro' ? 'border-gold' : 'border-gray-500'}`} data-id="element-246">
                    {selectedPlan === 'pro' && <div className="w-2.5 h-2.5 rounded-full bg-gold" data-id="element-247"></div>}
                  </div>

                  {/* Content */}
                  <div className="flex-1 min-w-0" data-id="element-248">
                    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4" data-id="element-249">
                      <div data-id="element-250">
                        <h3 className="text-xl font-bold text-white flex items-center gap-2 mb-1" data-id="element-251">
                          <span data-id="element-252">🏆</span> KIT ADULTO DE RESCATE + DECK TÁCTICO{' '}
                          <span className="text-yellow" data-id="element-253">⭐</span>
                        </h3>
                        <p className="text-gold text-sm font-medium mb-3" data-id="element-254">
                          6 Módulos + 4 Bonos + 50 Tarjetas de Respuesta Rápida
                        </p>
                        <div className="bg-gold/5 px-3 py-2 rounded-lg border border-gold/20 text-xs text-gray-300 inline-block" data-id="element-255">
                          <span className="font-semibold text-white" data-id="element-256">
                            Ideal para:
                          </span>{' '}
                          Padres que quieren tener la respuesta exacta para cada
                          situación sin tener que pensar en el momento
                        </div>
                      </div>
                      <div className="sm:text-right shrink-0" data-id="element-257">
                        <span className="text-gray-500 line-through text-sm block" data-id="element-258">
                          $72.000
                        </span>
                        <span className="text-3xl font-bold text-gold font-heading" data-id="element-259">
                          $27.990
                        </span>
                        <span className="text-sm text-gold/70 ml-1" data-id="element-260">ARS</span>
                      </div>
                    </div>
                  </div>
                </div>
              </button>
            </div>
          </FadeIn>

          {/* Single CTA Button */}
          <FadeIn delay={0.3} data-id="element-261">
            <a href={selectedPlan === 'pro' ? 'https://fegion.shop/cart/46824994341003:1' : 'https://fegion.shop/cart/46824945516683:1'} className="block w-full mt-6 py-5 text-center rounded-2xl font-bold text-background bg-gold hover:bg-gold/90 transition-all animate-pulse-glow shadow-lg uppercase tracking-wider text-lg" data-id="element-262">
              {selectedPlan === 'pro' ? '→ QUIERO EL KIT COMPLETO + DECK TÁCTICO' : '→ QUIERO MI KIT AHORA'}
            </a>
          </FadeIn>
        </div>

        {/* Comparison Table */}
        <FadeIn delay={0.2} data-id="element-263">
          <div className="max-w-4xl mx-auto mb-16" data-id="element-264">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-2 text-center" data-id="element-265">
              🕊️ ¿QUÉ AGREGA EL DECK TÁCTICO?
            </h3>
            <p className="text-gray-400 text-center mb-6" data-id="element-266">
              El sistema completo para nunca más quedarte sin saber qué decir
            </p>
            <p className="text-sm text-gray-400 mb-2 md:hidden text-center" data-id="element-267">
              ← Scroll to see full table →
            </p>
            <div className="overflow-x-auto pb-4" data-id="element-268">
              <table className="w-full min-w-[600px] text-left border-collapse" data-id="element-269">
                <thead data-id="element-270">
                  <tr data-id="element-271">
                    <th className="p-4 border-b border-white/10 text-gray-300 font-semibold bg-surfaceLight/30 rounded-tl-xl" data-id="element-272">
                      Situación en casa
                    </th>
                    <th className="p-4 border-b border-white/10 text-red-400 font-semibold bg-red-500/5" data-id="element-273">
                      ❌ Sin Deck
                    </th>
                    <th className="p-4 border-b border-white/10 text-gold font-semibold bg-gold/5 rounded-tr-xl" data-id="element-274">
                      ✅ Con Deck
                    </th>
                  </tr>
                </thead>
                <tbody className="text-sm md:text-base" data-id="element-275">
                  <tr className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-276">
                    <td className="p-4 text-gray-300" data-id="element-277">
                      Tu hijo explota y no sabés qué decir
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-278">
                      Improvisás y generalmente empeora
                    </td>
                    <td className="p-4 text-white bg-gold/5 font-medium" data-id="element-279">
                      Tarjeta ROJA. Protocolo exacto. 60 segundos.
                    </td>
                  </tr>
                  <tr className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-280">
                    <td className="p-4 text-gray-300" data-id="element-281">
                      Está ansioso antes de un examen
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-282">
                      Le decís "calmate" y se cierra más
                    </td>
                    <td className="p-4 text-white bg-gold/5 font-medium" data-id="element-283">
                      Tarjeta AZUL. Técnica física inmediata.
                    </td>
                  </tr>
                  <tr className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-284">
                    <td className="p-4 text-gray-300" data-id="element-285">
                      Silencio total, no habla hace días
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-286">
                      No sabés si presionar o esperar
                    </td>
                    <td className="p-4 text-white bg-gold/5 font-medium" data-id="element-287">
                      Tarjeta BLANCA. Apertura sin invasión.
                    </td>
                  </tr>
                  <tr className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-288">
                    <td className="p-4 text-gray-300" data-id="element-289">
                      Baja autoestima, se destruye solo/a
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-290">
                      Decís cosas que no ayudan sin querer
                    </td>
                    <td className="p-4 text-white bg-gold/5 font-medium" data-id="element-291">
                      Tarjeta DORADA. Frase de validación exacta.
                    </td>
                  </tr>
                  <tr className="hover:bg-white/5 transition-colors" data-id="element-292">
                    <td className="p-4 text-gray-300 rounded-bl-xl" data-id="element-293">
                      Después de una pelea fuerte
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-294">
                      El silencio se vuelve permanente
                    </td>
                    <td className="p-4 text-white bg-gold/5 font-medium rounded-br-xl" data-id="element-295">
                      Tarjeta VERDE. Protocolo de reparación.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </FadeIn>

        {/* Kit Includes */}
        <FadeIn delay={0.3} data-id="element-296">
          <div className="max-w-4xl mx-auto mb-20 bg-surfaceLight/30 rounded-3xl p-8 border border-white/5" data-id="element-297">
            <h3 className="text-2xl font-bold text-white mb-8 text-center" data-id="element-298">
              ✅ EL DECK INCLUYE:
            </h3>
            <p className="text-gray-300 text-center mb-6 font-medium" data-id="element-299">
              50 Tarjetas de Respuesta Rápida organizadas por color:
            </p>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-300">
              {['🔴 Tarjetas Rojas — Crisis y explosiones', '🟡 Tarjetas Amarillas — Tensión y señales de alerta', '🔵 Tarjetas Azules — Ansiedad y pánico', '🟢 Tarjetas Verdes — Reconexión y reparación', '⚪ Tarjetas Blancas — Silencio y cierre emocional', '🟤 Tarjetas Doradas — Autoestima y validación'].map((item, i) => <div key={i} className="flex items-start gap-3 bg-background/50 p-4 rounded-xl border border-white/5" data-id="element-301">
                  <span className="text-gray-300" data-id="element-302">{item}</span>
                </div>)}
            </div>
          </div>
        </FadeIn>

        {/* Testimonials */}
        <FadeIn delay={0.4} data-id="element-303">
          <div className="max-w-5xl mx-auto mb-24" data-id="element-304">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-10 text-center" data-id="element-305">
              ❤️ MÁS FAMILIAS QUE YA LO TIENEN
            </h3>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-306">
              {[{
              name: 'Cecilia R.',
              loc: '📍 Mendoza',
              plan: 'Kit + Deck Táctico',
              text: 'El Deck me salvó la vida. Mi hija estaba en plena crisis de ansiedad y yo tenía la tarjeta azul en la mano. Lo hice paso a paso y funcionó. Lloré de alivio.'
            }, {
              name: 'Roberto M.',
              loc: '📍 Buenos Aires',
              plan: 'Kit Adulto de Rescate',
              text: 'Llevaba 2 años sin poder hablar más de 5 minutos con mi hijo sin explotar. El módulo 1 me cambió la cabeza.'
            }, {
              name: 'Sofía C.',
              loc: '📍 La Plata',
              plan: 'Kit + Deck Táctico',
              text: 'Mi hijo de 16 años empezó a usar el Diario Silencioso por su cuenta. Sin que yo se lo pidiera. No lo podía creer.'
            }, {
              name: 'Pablo A.',
              loc: '📍 Neuquén',
              plan: 'Kit Adulto de Rescate',
              text: 'El Protocolo Sin Palabras fue un antes y un después. Ahora tenemos un sistema para cuando ninguno puede hablar. La tensión en casa bajó un 80%.'
            }].map((t, i) => <div key={i} className="bg-surfaceLight p-6 rounded-2xl border border-white/5" data-id="element-307">
                  <div className="flex gap-1 mb-3" data-id="element-308">
                    {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-yellow text-yellow" data-id="element-309" />)}
                  </div>
                  <p className="text-gray-300 mb-4 italic" data-id="element-310">"{t.text}"</p>
                  <div className="text-sm" data-id="element-311">
                    <span className="font-bold text-white" data-id="element-312">{t.name}</span>
                    <span className="text-gray-500 mx-2" data-id="element-313">|</span>
                    <span className="text-gray-400" data-id="element-314">{t.loc}</span>
                    <span className="text-gray-500 mx-2" data-id="element-315">|</span>
                    <span className="text-gold text-xs" data-id="element-316">{t.plan}</span>
                  </div>
                </div>)}
            </div>
          </div>
        </FadeIn>

        {/* Guarantee */}
        <FadeIn delay={0.5} data-id="element-317">
          <div className="max-w-3xl mx-auto bg-surfaceLight/50 rounded-3xl p-8 md:p-12 border border-white/5 text-center" data-id="element-318">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white/5 mb-6" data-id="element-319">
              <ShieldCheck className="w-8 h-8 text-white" data-id="element-320" />
            </div>
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-321">
              GARANTÍA 7 DÍAS — SIN PREGUNTAS
            </h3>
            <p className="text-gray-300 text-lg mb-6" data-id="element-322">
              Abrís el kit. Lo usás con tu hijo/a. Si en 7 días no es lo que
              esperabas:
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4 mb-6 text-white font-medium" data-id="element-323">
              <div className="flex items-center justify-center gap-2" data-id="element-324">
                <span className="text-green-400" data-id="element-325">✅</span> devolución del 100%
              </div>
              <div className="flex items-center justify-center gap-2" data-id="element-326">
                <span className="text-green-400" data-id="element-327">✅</span> sin formularios, sin
                drama.
              </div>
            </div>
            <div className="inline-block bg-background px-4 py-2 rounded-lg border border-white/10 text-sm text-gray-400" data-id="element-328">
              Tasa de devoluciones: menos del 1%.
            </div>
          </div>
        </FadeIn>

        {/* FAQ */}
        <FadeIn delay={0.6} data-id="element-329">
          <div className="max-w-3xl mx-auto mt-24" data-id="element-330">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-8 text-center" data-id="element-331">
              ❓ LO QUE MÁS NOS PREGUNTAN
            </h3>
            <div className="space-y-4" data-id="element-332">
              {[{
              q: '¿Sirve si mi hijo/a es muy cerrado/a y nunca quiere hacer nada?',
              a: 'Sí. La mayoría de las herramientas están diseñadas para adolescentes que rechazan la ayuda directa. No requieren que el adolescente coopere activamente para funcionar.'
            }, {
              q: '¿Cómo recibo el material?',
              a: 'Al confirmar tu pago recibís un email con acceso inmediato a todo el contenido. En menos de 5 minutos tenés todo disponible.'
            }, {
              q: '¿Qué lo diferencia de los libros de crianza que ya leí?',
              a: 'No es un libro de teoría. Es un sistema de herramientas tácticas listas para usar en el momento exacto de la crisis. Nada de entiende la neurociencia adolescente. Todo de hacé esto ahora.'
            }, {
              q: '¿Tengo que ser psicólogo para usarlo?',
              a: 'No. Las instrucciones están escritas en español claro, directo y sin tecnicismos. Si podés leer esto, podés aplicarlo.'
            }, {
              q: '¿Sirve para adolescentes con diagnóstico (TDAH, ansiedad clínica, etc.)?',
              a: 'Las herramientas son complementarias al acompañamiento profesional. No reemplazan la terapia pero sí potencian lo que el profesional ya está haciendo.'
            }].map((faq, i) => <div key={i} className="bg-surfaceLight border border-white/5 rounded-xl overflow-hidden" data-id="element-333">
                  <button onClick={() => setOpenFaq(openFaq === i ? null : i)} className="w-full px-6 py-4 text-left flex items-center justify-between focus:outline-none" data-id="element-334">
                    <span className="font-medium text-white pr-4" data-id="element-335">{faq.q}</span>
                    <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform shrink-0 ${openFaq === i ? 'rotate-180' : ''}`} data-id="element-336" />
                  </button>
                  {openFaq === i && <div className="px-6 pb-4 text-gray-400" data-id="element-337">{faq.a}</div>}
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}